/* eslint-disable */
export default function init(Blockly, profile, img_path) {
  Blockly.Blocks.thingspeak = {};
  Blockly.Blocks.thingspeak.style = "thingspeak_blocks";
  Blockly.Blocks.thingspeak_init_esp01 = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.setStyle(Blockly.Blocks.thingspeak.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.BLYNK_WIFI)
        .appendField(
          new Blockly.FieldImage(
            img_path + "arduino/thingspeak_logo.svg",
            100,
            35
          )
        )
        .appendField(Blockly.Msg.BLYNK_INIT + " (ESP-01 WiFi)"); //oJo, sacar leteral comun
        this.appendDummyInput()
        .appendField("Rx")
        .appendField(new Blockly.FieldDropdown(profile["default"].rxtx), "RX")
        .appendField("Tx")
        .appendField(new Blockly.FieldDropdown(profile["default"].rxtx), "TX")
        .appendField(
          new Blockly.FieldDropdown([
            ["2400", "2400"],
            ["4800", "4800"],
            ["9600", "9600"],
            ["19200", "19200"],
            ["38400", "38400"],
            ["57600", "57600"],
            ["115200", "115200"],
          ]),
          "BAUD"
        )
        .appendField(Blockly.Msg.BLYNK_BAUDRATE);
      this.appendDummyInput()
        .appendField(Blockly.Msg.BLYNK_WIFI_NAME)
        .appendField(new Blockly.FieldTextInput(""), "WIFINAME")
        .appendField(Blockly.Msg.BLYNK_WIFI_PASS)
        .appendField(new Blockly.FieldTextInput(""), "WIFIPASS");
      this.appendDummyInput()
        .appendField(Blockly.Msg.THINGSPEAK_WRITE_APIKEY)
        .appendField(new Blockly.FieldTextInput(""), "TS_W_KEY");
      this.setInputsInline(!1);
      this.setPreviousStatement(!0, null);
      this.setNextStatement(!0, null);
    },
  };
}
